<template>
    <section id="about" class="bg-white py-12 px-6 md:px-12">
        <div class="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10">
            <div class=" gap-4 justify-center lg:w-2/5">
                <h2 class="text-2xl md:text-3xl font-normal text-blue-900 pl-0 lg:pl-16">Welcome to
                    ChooseApp,<br />India's
                    First mobility Super App!</h2><img alt="ChooseApp Mockup 1" loading="lazy" width="600" height="600"
                    decoding="async" data-nimg="1" class="" style="color:transparent"
                    src="@/assets/chooseapp-mockup1.png" />
            </div>
            <div class="lg:w-3/5">
                <div class="mb-6">
                    <h2 class="text-2xl font-semibold mb-2">About us!</h2>
                    <p class="text-gray-700 leading-relaxed text-2xl"><span
                            class="font-bold text-blue-800">ChooseApp</span> is
                        India’s first Interoperable Mobility SuperApp, a one-stop platform that brings together all
                        major cab
                        aggregators, allowing users to compare cab prices, ETA, reviews, ratings and book the most
                        affordable and
                        convenient ride in seconds. We guarantee you the most affordable cab services, ensuring that you
                        always
                        get the most efficient deals!</p>
                </div>
                <div class="mb-6">
                    <div class="grid grid-cols-1 lg:grid-cols-2 gap-0 lg:gap-4">
                        <div class="flex-1">
                            <p class="font-semibold text-xl text-black">Download ChooseApp!</p>
                            <div class="flex  items-center gap-4 mt-2 min-w-64"><a href="#" target="_blank"
                                    rel="noopener noreferrer"><img alt="App Store" loading="lazy" width="500"
                                        height="83" decoding="async" data-nimg="1" class="max-w-64"
                                        style="color:transparent" src="@/assets/badges-3.png" /></a><img alt="QR Code"
                                    loading="lazy" width="100" height="100" decoding="async" data-nimg="1"
                                    style="color:transparent" src="@/assets/app-qr-code.jpg" /></div>
                        </div>
                        <div class="flex -gap-20 items-end"><img alt="24/7 Service" loading="lazy" width="180"
                                height="180" decoding="async" data-nimg="1" style="color:transparent"
                                src="@/assets/24_7_service.png" /><img alt="Best Price Guaranteed" loading="lazy"
                                width="180" height="180" decoding="async" data-nimg="1" class="-ml-16"
                                style="color:transparent" src="@/assets/best-price.png" /></div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <section id="our-partners" class=" py-10 md:py-16 lt:py-20 w-full text-xl">
        <div class="max-w-screen-lg mx-5 lg:mx-auto">
            <div class="text-center" style="opacity:1">
                <h2 class="font-bold text-black my-3">Our
                    Partners
                </h2>
                <p>At ChooseApp, we take pride in partnering
                    with
                    some of the most trusted names in transportation and logistics to create a truly unified mobility
                    experience. Our mobility partners include leading cab aggregators such as<!-- --> <span
                        class="font-bold">Rapido, Ola, Meru, Gozo Cabs, Savaari, CabBazar, Namma Yatri, Mega Cabs,
                        Carzonrent,
                        Yatri Sathi, Yaary, TaxiBazaar, O’Rickshaw, Baayu, QuickRide, Avis</span> <!-- -->and several
                    regional
                    operators across India.</p>
                <p class="mt-4">On the logistics front,
                    ChooseApp
                    offers Logistics as a Service (LaaS), powered by partners like <span class="font-bold">Borzo</span>
                    and<!-- --> <span class="font-bold">Porter</span>, enabling hyperlocal deliveries and last-mile
                    connectivity
                    with speed and reliability.</p>
            </div>
            <div
                class="bg-gray-200 p-5 md:grid gap-8 grid grid-cols-2 md:grid-cols-6 items-center justify-between mt-12 pt-5">
                <div><img alt="" src="@/assets/rapido.jpg"
                        class=" w-auto h-14 mb-3 md:mb-0 mx-auto bg-white rounded-xl shadow-xl" /></div>
                <div><img alt="" src="@/assets/meru.jpg"
                        class=" w-auto h-14 mb-3 md:mb-0 mx-auto bg-white rounded-xl shadow-xl" /></div>
                <div><img alt="" src="@/assets/gozo.jpg"
                        class=" w-auto h-14 mb-3 md:mb-0 mx-auto bg-white rounded-xl shadow-xl" /></div>
                <div><img alt="" src="@/assets/cabbazar.png"
                        class=" w-auto h-14 mb-3 md:mb-0 mx-auto bg-white rounded-xl shadow-xl" /></div>
                <div><img alt="" src="@/assets/avis.jpg"
                        class=" w-auto h-14 mb-3 md:mb-0 mx-auto bg-white rounded-xl shadow-xl" /></div>
                <div><img alt="" src="@/assets/carzonrent.jpg"
                        class=" w-auto h-14 mb-3 md:mb-0 mx-auto bg-white rounded-xl shadow-xl" /></div>
                <div><img alt="" src="@/assets/bazaar.png"
                        class=" w-auto h-14 mb-3 md:mb-0 mx-auto bg-white rounded-xl shadow-xl" /></div>
                <div><img alt="" src="@/assets/baayu.jpg"
                        class=" w-auto h-14 mb-3 md:mb-0 mx-auto bg-white rounded-xl shadow-xl" /></div>
                <div><img alt="" src="@/assets/mega%20cabs.jpg"
                        class=" w-auto h-14 mb-3 md:mb-0 mx-auto bg-white rounded-xl shadow-xl" /></div>
                <div><img alt="" src="@/assets/namma%20yatri.jpg"
                        class=" w-auto h-14 mb-3 md:mb-0 mx-auto bg-white rounded-xl shadow-xl" /></div>
                <div><img alt="" src="@/assets/ola.jpg"
                        class=" w-auto h-14 mb-3 md:mb-0 mx-auto bg-white rounded-xl shadow-xl" /></div>
                <div><img alt="" src="@/assets/orishkawa.png"
                        class=" w-auto h-14 mb-3 md:mb-0 mx-auto bg-white rounded-xl shadow-xl" /></div>
                <div><img alt="" src="@/assets/quick-ride.jpg"
                        class=" w-auto h-14 mb-3 md:mb-0 mx-auto bg-white rounded-xl shadow-xl" /></div>
                <div><img alt="" src="@/assets/yarri.jpg"
                        class=" w-auto h-14 mb-3 md:mb-0 mx-auto bg-white rounded-xl shadow-xl" /></div>
                <div><img alt="" src="@/assets/yatri-sathi.jpg"
                        class=" w-auto h-14 mb-3 md:mb-0 mx-auto bg-white rounded-xl shadow-xl" /></div>
                <div><img alt="" src="@/assets/savaari_logo.png"
                        class=" w-auto h-14 mb-3 md:mb-0 mx-auto bg-white rounded-xl shadow-xl" /></div>
                <div><img alt="" src="@/assets/borzo.png"
                        class=" w-auto h-14 mb-3 md:mb-0 mx-auto bg-white rounded-xl shadow-xl" /></div>
                <div><img alt="" src="@/assets/porter.png"
                        class=" w-auto h-14 mb-3 md:mb-0 mx-auto bg-white rounded-xl shadow-xl" /></div>
            </div>
        </div>
    </section>
    <section id="partner" class="bg-white py-10 md:py-16 lt:py-20">
        <div class="max-w-screen-xl mx-5 lg:mx-auto">
            <div class="text-center mb-6 md:mb-8">
                <div class="font-bold text-black my-3 text-2xl">
                    Partner +</div>
                <p class="text-center max-w-screen-md mx-auto">
                    Join the ChooseApp partner network and elevate your reach as a premier transportation service
                    provider.
                    Let&#x27;s drive the future of urban mobility together – partner with Choose App today!</p>
                <div class="font-bold text-black my-3 text-2xl">
                    Partner Benefits</div>
            </div>
            <div class="grid grid-cols-1 md:grid-cols-3 gap-3 items-start justify-between">
                <div>
                    <div class="flex justify-start lg:ml-20"><img alt="Big On Visibility" loading="lazy" width="128"
                            height="128" decoding="async" data-nimg="1" class="self-start w-16 h-16 mr-4"
                            style="color:transparent" src="@/assets/ico_vision.png" />
                        <div>
                            <h5 class="font-semibold mb-2">Big On Visibility</h5>
                            <p>Say goodbye to hiding in the shadows! Get seen by more customers.</p>
                        </div>
                    </div>
                    <div class="flex justify-start my-6 md:my-8">
                        <img alt="City Domination" loading="lazy" width="128" height="128" decoding="async"
                            data-nimg="1" class="self-start w-16 h-16 mr-4" style="color:transparent"
                            src="@/assets/ico_city.png" />
                        <div>
                            <h5 class="font-semibold mb-2">City Domination</h5>
                            <p>Enter new markets and expand your services &amp; your territory and become the go-to hero
                                in your
                                city!</p>
                        </div>
                    </div>
                    <div class="flex justify-start lg:ml-20"><img alt="Reviews that Rock" loading="lazy" width="128"
                            height="128" decoding="async" data-nimg="1" class="self-start w-16 h-16 mr-4"
                            style="color:transparent" src="@/assets/ico_reviews.png" />
                        <div>
                            <h5 class="font-semibold mb-2">Reviews that Rock</h5>
                            <p>Enter new markets and expand your services &amp; your territory and become the go-to hero
                                in your
                                city!</p>
                        </div>
                    </div>
                </div>
                <div><img alt="Car" loading="lazy" width="554" height="484" decoding="async" data-nimg="1"
                        class="object-cover" style="color:transparent" src="@/assets/car.png" /></div>
                <div>
                    <div class="flex justify-start lg:-ml-20 lg:pr-24"><img alt="Market Penetration" loading="lazy"
                            width="128" height="128" decoding="async" data-nimg="1" class="self-start w-16 h-16 mr-4"
                            style="color:transparent" src="@/assets/ico_penetration.png" />
                        <div>
                            <h5 class="font-semibold mb-2">Market Penetration</h5>
                            <p>Highlight your unique services and stand out from the crowd with competitive advantage.
                            </p>
                        </div>
                    </div>
                    <div class="flex justify-start my-6 md:my-8 lg:pr-28"><img alt="Seamless Booking" loading="lazy"
                            width="128" height="128" decoding="async" data-nimg="1" class="self-start w-16 h-16 mr-4"
                            style="color:transparent" src="@/assets/ico_booking.png" />
                        <div>
                            <h5 class="font-semibold mb-2">Seamless Booking</h5>
                            <p>Hassle-free booking process integrated with major payment gateway</p>
                        </div>
                    </div>
                    <div class="flex justify-start -ml-0 lg:-ml-20 lg:pr-24"><img alt="Top-Notch Security"
                            loading="lazy" width="128" height="128" decoding="async" data-nimg="1"
                            class="self-start w-16 h-16 mr-4" style="color:transparent"
                            src="@/assets/ico_security.png" />
                        <div>
                            <h5 class="font-semibold mb-2">Top-Notch Security</h5>
                            <p>Ironclad protection for all transactions and data.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <section id="investors" class="black-tint py-10 md:py-16 lg:py-20 relative"><img alt="Investors."
            loading="lazy" decoding="async" data-nimg="fill"
            class="absolute w-full object-cover h-full z-10 opacity-20"
            style="position:absolute;height:100%;width:100%;left:0;top:0;right:0;bottom:0;color:transparent"
            src="@/assets/investor_bg.jpg" />
        <div class="max-w-screen-lg mx-5 lg:mx-auto text-xl relative z-10">
            <div class="text-center text-black">
                <h2 class="font-bold mb-6 md:mb-8"><span class="text-customBlue-700">Investors</span></h2>
                <p>Invest in the future of mobility with ChooseApp, India&#x27;s leading transportation super app. With
                    our
                    innovative platform, we aggregate top cab services, providing unmatched convenience and choice to
                    commuters
                    nationwide.</p>
                <p>As we expand and scale, we invite visionary investors to join us in revolutionising urban
                    transportation.
                    With a rapidly growing user base, strategic partnerships, and a commitment to excellence, ChooseApp
                    is
                    poised for exponential growth. Be a part of our journey and drive the future of mobility in India.
                </p>
            </div>
        </div>
    </section>
    <section id="press" class="py-10 md:py-16 lt:py-24">
        <div class="max-w-screen-lg mx-5 lg:mx-auto">
            <div class="text-center ">
                <h2 class="font-bold text-black mb-6 md:mb-8">Press</h2>
                <p>Latest news, updates, and media coverage about ChooseApp. Stay informed and connected with ChooseApp
                    as we
                    drive innovation and convenience in the world of commuting.</p>
                <div>
                    <div class="mt-10">
                        <h3 class="text-2xl font-bold max-w-screen-sm mx-auto">Tired of High Cab Fares? Compare &amp;
                            Book the
                            Cheapest Ride with ChooseApp!</h3>
                        <div class="flex flex-col md:flex-row max-w-screen-sm mx-auto">
                            <div class="w-full md:w-80 mr-0 md:mr-8 mb-4 md:mb-0"><img alt="Press" loading="lazy"
                                    width="1269" height="846" decoding="async" data-nimg="1" class="w-full"
                                    style="color:transparent" src="@/assets/press-startuppedia.png" /></div>
                            <div class="flex-1 text-justify">Founded in 2024, ChooseApp is India’s first super mobility
                                app where
                                users can seamlessly compare prices, ratings, wait times, and reviews from various cab
                                aggregators
                                across India and then book the best option directly on the app.<div class="mt-4"><a
                                        href="https://startuppedia.in/startup-stories/tired-of-high-cab-fares-compare-book-the-cheapest-ride-with-chooseapp-7776818"
                                        class="font-bold" target="_blank">Read More</a></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <div class="mt-10">
                        <h3 class="text-2xl font-bold max-w-screen-sm mx-auto">Is ChooseApp India&#x27;s newest mobility
                            disruptor? Compare and Book the Cheapest Cabs Now!</h3>
                        <div class="flex flex-col md:flex-row max-w-screen-sm mx-auto">
                            <div class="w-full md:w-80 mr-4 md:mr-8 mb-4 md:mb-0"><img
                                    alt="Is ChooseApp India&#x27;s newest mobility disruptor? Compare and Book the Cheapest Cabs Now!"
                                    loading="lazy" width="1269" height="846" decoding="async" data-nimg="1"
                                    class="w-full" style="color:transparent" src="@/assets/press-2.jpg" /></div>
                            <div class="flex-1 text-justify">ChooseApp the game-changing platform created by media
                                professionals, is
                                disrupting the mobility industry with 15,000 downloads in just 10 days. The App lets you
                                instantly
                                compare cab prices, wait times, and reviews across multiple services, making travel
                                affordable,
                                reliable, and stress-free.<div class="mt-4"><a
                                        href="https://www.mid-day.com/buzz/article/is-chooseapp-indias-newest-mobility-disruptor-compare-and-book-the-cheapest-cabs-now-3723"
                                        class="font-bold" target="_blank">Read More</a></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <section id="contact-us" class="bg-gray-200 py-10 md:py-20 lt:py-24 w-full">
        <div class="max-w-screen-xl mx-5 lg:mx-auto">
            <div class="flex flex-col md:flex-row gap-3 md:gap-6 items-start justify-between">
                <div class="w-full md:w-1/2 order-2 md:order-1">
                    <h2 class="font-bold text-black my-3">Contact <span class="text-yellow-400">Us</span></h2>
                    <p>We&#x27;d love to hear from you! Whether you have questions, feedback, or need assistance, our
                        team is
                        here to help. Reach out to us through any of the following channels:</p>
                    <div>
                        <h4 class="text-xl font-semibold mt-4">Email: </h4>
                        <div>team@choosecabs.com</div>
                        <h4 class="text-xl font-semibold mt-6">Address:</h4>
                        <div>NVS Choose Cabs India Pvt Ltd, <br />105, Stanford Plaza, Off Link Road, Andheri West
                            Mumbai 400053
                        </div>
                        <div class="flex flex-col items-start">
                            <h4 class="text-xl font-semibold mt-6">Connect with us:</h4>
                            <div class="flex items-center space-x-4"><a href="https://facebook.com/choosecabs"
                                    target="_blank" rel="noopener noreferrer" class="flex items-center space-x-2"><svg
                                        stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 512 512"
                                        height="32" width="32" xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M504 256C504 119 393 8 256 8S8 119 8 256c0 123.78 90.69 226.38 209.25 245V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.28c-30.8 0-40.41 19.12-40.41 38.73V256h68.78l-11 71.69h-57.78V501C413.31 482.38 504 379.78 504 256z">
                                        </path>
                                    </svg></a><a href="https://www.linkedin.com/company/chooseappindia/" target="_blank"
                                    rel="noopener noreferrer" class="flex items-center space-x-2"><svg
                                        stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 448 512"
                                        height="32" width="32" xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M416 32H31.9C14.3 32 0 46.5 0 64.3v383.4C0 465.5 14.3 480 31.9 480H416c17.6 0 32-14.5 32-32.3V64.3c0-17.8-14.4-32.3-32-32.3zM135.4 416H69V202.2h66.5V416zm-33.2-243c-21.3 0-38.5-17.3-38.5-38.5S80.9 96 102.2 96c21.2 0 38.5 17.3 38.5 38.5 0 21.3-17.2 38.5-38.5 38.5zm282.1 243h-66.4V312c0-24.8-.5-56.7-34.5-56.7-34.6 0-39.9 27-39.9 54.9V416h-66.4V202.2h63.7v29.2h.9c8.9-16.8 30.6-34.5 62.9-34.5 67.2 0 79.7 44.3 79.7 101.9V416z">
                                        </path>
                                    </svg></a><a href="https://www.instagram.com/chooseappindia?igsh=ZDA1ZmRlZzh2ajYz"
                                    target="_blank" rel="noopener noreferrer" class="flex items-center space-x-2"><svg
                                        stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 448 512"
                                        height="32" width="32" xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z">
                                        </path>
                                    </svg></a></div>
                        </div>
                        <div class="flex flex-col items-start">
                            <h4 class="text-xl font-semibold mt-6">Links:</h4>
                            <ul class="md:space-y-3">
                                <l1><a class="text-gray-900 hover:text-orange-500" href="privacy-policy.html">Privacy
                                        Policy</a></l1>
                                <l1><a class="text-gray-900 hover:text-orange-500" href="refund-policy.html">Refund
                                        Policy</a></l1>
                                <l1><a class="text-gray-900 hover:text-orange-500"
                                        href="terms-and-conditions.html">Terms and
                                        Conditions</a></l1>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="grow order-1 md:order-2">
                    <div class="flex md:flex-row gap-4 bg-gray-300 px-6 py-2 rounded-2xl">
                        <div>
                            <p class="text-base md:text-lg font-semibold mt-6">How Can We Help You?</p>
                            <h3 class="font-bold text-black my-3">Have a Question?</h3>
                            <p>If you have any comments, suggestions or questions, please do not hesitate to contact us.
                                Our
                                high-quality office staff will help you and answer all your questions.</p>
                            <form class="space-y-8" action="#">
                                <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
                                    <div><label
                                            class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Your
                                            Name</label><input type="text" id="first_name"
                                            class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                                            placeholder="John" required="" /></div>
                                    <div><label
                                            class="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300">Your
                                            Email</label><input type="email" id="email"
                                            class="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5"
                                            placeholder="name@flowbite.com" required="" /></div>
                                    <div><label
                                            class="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300">Phone
                                            Number</label><input type="text" id="phone"
                                            class="block p-3 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 shadow-sm focus:ring-primary-500 focus:border-primary-500"
                                            placeholder="Phone Number" required="" /></div>
                                    <div><label
                                            class="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300">Your
                                            City</label><input type="text" id="city"
                                            class="block p-3 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 shadow-sm focus:ring-primary-500 focus:border-primary-500"
                                            placeholder="Your City..." required="" /></div>
                                </div>
                                <div class="sm:col-span-2"><label
                                        class="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-400">Your
                                        message</label><textarea id="message" rows="6"
                                        class="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg shadow-sm border border-gray-300 focus:ring-primary-500 focus:border-primary-500"
                                        placeholder="Leave a comment..."></textarea></div><button type="submit"
                                    class="py-3 px-5 text-sm font-medium text-center text-white rounded-lg bg-black sm:w-fit hover:bg-yellow-500 uppercase focus:ring-4 focus:outline-none focus:ring-primary-300">Send
                                    A Request</button>
                            </form>
                        </div>
                        <div class="self-center"><img alt="Send A Request" loading="lazy" width="477" height="556"
                                decoding="async" data-nimg="1" class=" object-cover m-auto w-[40rem] hidden md:block"
                                style="color:transparent" src="@/assets/choosecab_app.png" /></div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
// import '../assets/homecontent.css'
export default {
    // your component logic
}
</script>
<style scoped>
@font-face {
    font-family: __Inter_e8ce0c;
    font-style: normal;
    font-weight: 100 900;
    font-display: swap;
    src: url(../media/55c55f0601d81cf3-s.woff2) format("woff2");
    unicode-range: u+0460-052f, u+1c80-1c8a, u+20b4, u+2de0-2dff, u+a640-a69f, u+fe2e-fe2f
}

@font-face {
    font-family: __Inter_e8ce0c;
    font-style: normal;
    font-weight: 100 900;
    font-display: swap;
    src: url(../media/26a46d62cd723877-s.woff2) format("woff2");
    unicode-range: u+0301, u+0400-045f, u+0490-0491, u+04b0-04b1, u+2116
}

@font-face {
    font-family: __Inter_e8ce0c;
    font-style: normal;
    font-weight: 100 900;
    font-display: swap;
    src: url(../media/97e0cb1ae144a2a9-s.woff2) format("woff2");
    unicode-range: u+1f??
}

@font-face {
    font-family: __Inter_e8ce0c;
    font-style: normal;
    font-weight: 100 900;
    font-display: swap;
    src: url(../media/581909926a08bbc8-s.woff2) format("woff2");
    unicode-range: u+0370-0377, u+037a-037f, u+0384-038a, u+038c, u+038e-03a1, u+03a3-03ff
}

@font-face {
    font-family: __Inter_e8ce0c;
    font-style: normal;
    font-weight: 100 900;
    font-display: swap;
    src: url(../media/df0a9ae256c0569c-s.woff2) format("woff2");
    unicode-range: u+0102-0103, u+0110-0111, u+0128-0129, u+0168-0169, u+01a0-01a1, u+01af-01b0, u+0300-0301, u+0303-0304, u+0308-0309, u+0323, u+0329, u+1ea0-1ef9, u+20ab
}

@font-face {
    font-family: __Inter_e8ce0c;
    font-style: normal;
    font-weight: 100 900;
    font-display: swap;
    src: url(../media/8e9860b6e62d6359-s.woff2) format("woff2");
    unicode-range: u+0100-02ba, u+02bd-02c5, u+02c7-02cc, u+02ce-02d7, u+02dd-02ff, u+0304, u+0308, u+0329, u+1d00-1dbf, u+1e00-1e9f, u+1ef2-1eff, u+2020, u+20a0-20ab, u+20ad-20c0, u+2113, u+2c60-2c7f, u+a720-a7ff
}

@font-face {
    font-family: __Inter_e8ce0c;
    font-style: normal;
    font-weight: 100 900;
    font-display: swap;
    src: url(../media/e4af272ccee01ff0-s.p.woff2) format("woff2");
    unicode-range: u+00??, u+0131, u+0152-0153, u+02bb-02bc, u+02c6, u+02da, u+02dc, u+0304, u+0308, u+0329, u+2000-206f, u+20ac, u+2122, u+2191, u+2193, u+2212, u+2215, u+feff, u+fffd
}

@font-face {
    font-family: __Inter_Fallback_e8ce0c;
    src: local("Arial");
    ascent-override: 90.49%;
    descent-override: 22.56%;
    line-gap-override: 0.00%;
    size-adjust: 107.06%
}

.__className_e8ce0c {
    font-family: __Inter_e8ce0c, __Inter_Fallback_e8ce0c;
    font-style: normal
}

@import"https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,100..1000;1,9..40,100..1000&amp;family=Kristi&amp;family=Lato:ital,wght@0,100;0,300;0,400;0,700;0,900;1,100;1,300;1,400;1,700;1,900&amp;display=swap";

/*
! tailwindcss v3.4.4 | MIT License | https://tailwindcss.com
*/
*,
:after,
:before {
    box-sizing: border-box;
    border: 0 solid #e5e7eb
}

:after,
:before {
    --tw-content: ""
}

:host,
html {
    line-height: 1.5;
    -webkit-text-size-adjust: 100%;
    -moz-tab-size: 4;
    tab-size: 4;
    font-family: ui-sans-serif, system-ui, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji;
    font-feature-settings: normal;
    font-variation-settings: normal;
    -webkit-tap-highlight-color: transparent
}

body {
    margin: 0;
    line-height: inherit
}

hr {
    height: 0;
    color: inherit;
    border-top-width: 1px
}

abbr:where([title]) {
    text-decoration: underline dotted
}

h1,
h2,
h3,
h4,
h5,
h6 {
    font-size: inherit;
    font-weight: inherit
}

a {
    color: inherit;
    text-decoration: inherit
}

b,
strong {
    font-weight: bolder
}

code,
kbd,
pre,
samp {
    font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, Liberation Mono, Courier New, monospace;
    font-feature-settings: normal;
    font-variation-settings: normal;
    font-size: 1em
}

small {
    font-size: 80%
}

sub,
sup {
    font-size: 75%;
    line-height: 0;
    position: relative;
    vertical-align: baseline
}

sub {
    bottom: -.25em
}

sup {
    top: -.5em
}

table {
    text-indent: 0;
    border-color: inherit;
    border-collapse: collapse
}

button,
input,
optgroup,
select,
textarea {
    font-family: inherit;
    font-feature-settings: inherit;
    font-variation-settings: inherit;
    font-size: 100%;
    font-weight: inherit;
    line-height: inherit;
    letter-spacing: inherit;
    color: inherit;
    margin: 0;
    padding: 0
}

button,
select {
    text-transform: none
}

button,
input:where([type=button]),
input:where([type=reset]),
input:where([type=submit]) {
    -webkit-appearance: button;
    background-color: transparent;
    background-image: none
}

:-moz-focusring {
    outline: auto
}

:-moz-ui-invalid {
    box-shadow: none
}

progress {
    vertical-align: baseline
}

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
    height: auto
}

[type=search] {
    -webkit-appearance: textfield;
    outline-offset: -2px
}

::-webkit-search-decoration {
    -webkit-appearance: none
}

::-webkit-file-upload-button {
    -webkit-appearance: button;
    font: inherit
}

summary {
    display: list-item
}

blockquote,
dd,
dl,
figure,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
p,
pre {
    margin: 0
}

fieldset {
    margin: 0
}

fieldset,
legend {
    padding: 0
}

menu,
ol,
ul {
    list-style: none;
    margin: 0;
    padding: 0
}

dialog {
    padding: 0
}

textarea {
    resize: vertical
}

input::placeholder,
textarea::placeholder {
    opacity: 1;
    color: #9ca3af
}

[role=button],
button {
    cursor: pointer
}

:disabled {
    cursor: default
}

audio,
canvas,
embed,
iframe,
img,
object,
svg,
video {
    display: block;
    vertical-align: middle
}

img,
video {
    max-width: 100%;
    height: auto
}

[hidden] {
    display: none
}

*,
:after,
:before {
    --tw-border-spacing-x: 0;
    --tw-border-spacing-y: 0;
    --tw-translate-x: 0;
    --tw-translate-y: 0;
    --tw-rotate: 0;
    --tw-skew-x: 0;
    --tw-skew-y: 0;
    --tw-scale-x: 1;
    --tw-scale-y: 1;
    --tw-pan-x: ;
    --tw-pan-y: ;
    --tw-pinch-zoom: ;
    --tw-scroll-snap-strictness: proximity;
    --tw-gradient-from-position: ;
    --tw-gradient-via-position: ;
    --tw-gradient-to-position: ;
    --tw-ordinal: ;
    --tw-slashed-zero: ;
    --tw-numeric-figure: ;
    --tw-numeric-spacing: ;
    --tw-numeric-fraction: ;
    --tw-ring-inset: ;
    --tw-ring-offset-width: 0px;
    --tw-ring-offset-color: #fff;
    --tw-ring-color: rgba(59, 130, 246, .5);
    --tw-ring-offset-shadow: 0 0 #0000;
    --tw-ring-shadow: 0 0 #0000;
    --tw-shadow: 0 0 #0000;
    --tw-shadow-colored: 0 0 #0000;
    --tw-blur: ;
    --tw-brightness: ;
    --tw-contrast: ;
    --tw-grayscale: ;
    --tw-hue-rotate: ;
    --tw-invert: ;
    --tw-saturate: ;
    --tw-sepia: ;
    --tw-drop-shadow: ;
    --tw-backdrop-blur: ;
    --tw-backdrop-brightness: ;
    --tw-backdrop-contrast: ;
    --tw-backdrop-grayscale: ;
    --tw-backdrop-hue-rotate: ;
    --tw-backdrop-invert: ;
    --tw-backdrop-opacity: ;
    --tw-backdrop-saturate: ;
    --tw-backdrop-sepia: ;
    --tw-contain-size: ;
    --tw-contain-layout: ;
    --tw-contain-paint: ;
    --tw-contain-style:
}

::backdrop {
    --tw-border-spacing-x: 0;
    --tw-border-spacing-y: 0;
    --tw-translate-x: 0;
    --tw-translate-y: 0;
    --tw-rotate: 0;
    --tw-skew-x: 0;
    --tw-skew-y: 0;
    --tw-scale-x: 1;
    --tw-scale-y: 1;
    --tw-pan-x: ;
    --tw-pan-y: ;
    --tw-pinch-zoom: ;
    --tw-scroll-snap-strictness: proximity;
    --tw-gradient-from-position: ;
    --tw-gradient-via-position: ;
    --tw-gradient-to-position: ;
    --tw-ordinal: ;
    --tw-slashed-zero: ;
    --tw-numeric-figure: ;
    --tw-numeric-spacing: ;
    --tw-numeric-fraction: ;
    --tw-ring-inset: ;
    --tw-ring-offset-width: 0px;
    --tw-ring-offset-color: #fff;
    --tw-ring-color: rgba(59, 130, 246, .5);
    --tw-ring-offset-shadow: 0 0 #0000;
    --tw-ring-shadow: 0 0 #0000;
    --tw-shadow: 0 0 #0000;
    --tw-shadow-colored: 0 0 #0000;
    --tw-blur: ;
    --tw-brightness: ;
    --tw-contrast: ;
    --tw-grayscale: ;
    --tw-hue-rotate: ;
    --tw-invert: ;
    --tw-saturate: ;
    --tw-sepia: ;
    --tw-drop-shadow: ;
    --tw-backdrop-blur: ;
    --tw-backdrop-brightness: ;
    --tw-backdrop-contrast: ;
    --tw-backdrop-grayscale: ;
    --tw-backdrop-hue-rotate: ;
    --tw-backdrop-invert: ;
    --tw-backdrop-opacity: ;
    --tw-backdrop-saturate: ;
    --tw-backdrop-sepia: ;
    --tw-contain-size: ;
    --tw-contain-layout: ;
    --tw-contain-paint: ;
    --tw-contain-style:
}

.container {
    width: 100%
}

@media (min-width:640px) {
    .container {
        max-width: 640px
    }
}

@media (min-width:768px) {
    .container {
        max-width: 768px
    }
}

@media (min-width:1024px) {
    .container {
        max-width: 1024px
    }
}

@media (min-width:1280px) {
    .container {
        max-width: 1280px
    }
}

@media (min-width:1536px) {
    .container {
        max-width: 1536px
    }
}

.sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border-width: 0
}

.visible {
    visibility: visible
}

.fixed {
    position: fixed
}

.absolute {
    position: absolute
}

.relative {
    position: relative
}

.sticky {
    position: sticky
}

.inset-y-0 {
    top: 0;
    bottom: 0
}

.left-0 {
    left: 0
}

.top-0 {
    top: 0
}

.-z-10 {
    z-index: -10
}

.-z-20 {
    z-index: -20
}

.z-10 {
    z-index: 10
}

.z-\[999\] {
    z-index: 999
}

.order-1 {
    order: 1
}

.order-2 {
    order: 2
}

.col-span-1 {
    grid-column: span 1/span 1
}

.col-span-full {
    grid-column: 1/-1
}

.row-span-2 {
    grid-row: span 2/span 2
}

.m-auto {
    margin: auto
}

.mx-1 {
    margin-left: .25rem;
    margin-right: .25rem
}

.mx-5 {
    margin-left: 1.25rem;
    margin-right: 1.25rem
}

.mx-auto {
    margin-left: auto;
    margin-right: auto
}

.my-3 {
    margin-top: .75rem;
    margin-bottom: .75rem
}

.my-6 {
    margin-top: 1.5rem;
    margin-bottom: 1.5rem
}

.my-8 {
    margin-top: 2rem;
    margin-bottom: 2rem
}

.-ml-0 {
    margin-left: 0
}

.-ml-16 {
    margin-left: -4rem
}

.mb-10 {
    margin-bottom: 2.5rem
}

.mb-2 {
    margin-bottom: .5rem
}

.mb-3 {
    margin-bottom: .75rem
}

.mb-4 {
    margin-bottom: 1rem
}

.mb-6 {
    margin-bottom: 1.5rem
}

.mb-8 {
    margin-bottom: 2rem
}

.ml-2 {
    margin-left: .5rem
}

.ml-3 {
    margin-left: .75rem
}

.ml-6 {
    margin-left: 1.5rem
}

.mr-0 {
    margin-right: 0
}

.mr-10 {
    margin-right: 2.5rem
}

.mr-2 {
    margin-right: .5rem
}

.mr-3 {
    margin-right: .75rem
}

.mr-4 {
    margin-right: 1rem
}

.mt-1 {
    margin-top: .25rem
}

.mt-10 {
    margin-top: 2.5rem
}

.mt-12 {
    margin-top: 3rem
}

.mt-2 {
    margin-top: .5rem
}

.mt-4 {
    margin-top: 1rem
}

.mt-6 {
    margin-top: 1.5rem
}

.mt-8 {
    margin-top: 2rem
}

.block {
    display: block
}

.flex {
    display: flex
}

.inline-flex {
    display: inline-flex
}

.grid {
    display: grid
}

.contents {
    display: contents
}

.hidden {
    display: none
}

.h-14 {
    height: 3.5rem
}

.h-16 {
    height: 4rem
}

.h-24 {
    height: 6rem
}

.h-5 {
    height: 1.25rem
}

.h-56 {
    height: 14rem
}

.h-6 {
    height: 1.5rem
}

.h-full {
    height: 100%
}

.w-16 {
    width: 4rem
}

.w-36 {
    width: 9rem
}

.w-40 {
    width: 10rem
}

.w-5 {
    width: 1.25rem
}

.w-52 {
    width: 13rem
}

.w-56 {
    width: 14rem
}

.w-6 {
    width: 1.5rem
}

.w-64 {
    width: 16rem
}

.w-\[10rem\] {
    width: 10rem
}

.w-\[40rem\] {
    width: 40rem
}

.w-auto {
    width: auto
}

.w-full {
    width: 100%
}

.min-w-36 {
    min-width: 9rem
}

.min-w-64 {
    min-width: 16rem
}

.max-w-4xl {
    max-width: 56rem
}

.max-w-5xl {
    max-width: 64rem
}

.max-w-64 {
    max-width: 16rem
}

.max-w-6xl {
    max-width: 72rem
}

.max-w-7xl {
    max-width: 80rem
}

.max-w-full {
    max-width: 100%
}

.max-w-screen-2xl {
    max-width: 1536px
}

.max-w-screen-lg {
    max-width: 1024px
}

.max-w-screen-md {
    max-width: 768px
}

.max-w-screen-sm {
    max-width: 640px
}

.max-w-screen-xl {
    max-width: 1280px
}

.flex-1 {
    flex: 1 1 0%
}

.flex-shrink-0 {
    flex-shrink: 0
}

.flex-grow,
.grow {
    flex-grow: 1
}

.-translate-y-full {
    --tw-translate-y: -100%
}

.-translate-y-full,
.rotate-180 {
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))
}

.rotate-180 {
    --tw-rotate: 180deg
}

.transform {
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))
}

.cursor-pointer {
    cursor: pointer
}

.list-inside {
    list-style-position: inside
}

.list-\[upper-roman\] {
    list-style-type: upper-roman
}

.list-decimal {
    list-style-type: decimal
}

.list-disc {
    list-style-type: disc
}

.list-none {
    list-style-type: none
}

.grid-cols-1 {
    grid-template-columns: repeat(1, minmax(0, 1fr))
}

.grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr))
}

.flex-row {
    flex-direction: row
}

.flex-col {
    flex-direction: column
}

.items-start {
    align-items: flex-start
}

.items-end {
    align-items: flex-end
}

.items-center {
    align-items: center
}

.justify-start {
    justify-content: flex-start
}

.justify-end {
    justify-content: flex-end
}

.justify-center {
    justify-content: center
}

.justify-between {
    justify-content: space-between
}

.gap-0 {
    gap: 0
}

.gap-10 {
    gap: 2.5rem
}

.gap-2 {
    gap: .5rem
}

.gap-3 {
    gap: .75rem
}

.gap-4 {
    gap: 1rem
}

.gap-6 {
    gap: 1.5rem
}

.gap-8 {
    gap: 2rem
}

.gap-x-2 {
    column-gap: .5rem
}

.space-x-2>:not([hidden])~:not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(.5rem * var(--tw-space-x-reverse));
    margin-left: calc(.5rem * calc(1 - var(--tw-space-x-reverse)))
}

.space-x-3>:not([hidden])~:not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(.75rem * var(--tw-space-x-reverse));
    margin-left: calc(.75rem * calc(1 - var(--tw-space-x-reverse)))
}

.space-x-4>:not([hidden])~:not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(1rem * var(--tw-space-x-reverse));
    margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse)))
}

.space-x-8>:not([hidden])~:not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(2rem * var(--tw-space-x-reverse));
    margin-left: calc(2rem * calc(1 - var(--tw-space-x-reverse)))
}

.space-y-1>:not([hidden])~:not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(.25rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(.25rem * var(--tw-space-y-reverse))
}

.space-y-10>:not([hidden])~:not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(2.5rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(2.5rem * var(--tw-space-y-reverse))
}

.space-y-12>:not([hidden])~:not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(3rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(3rem * var(--tw-space-y-reverse))
}

.space-y-2>:not([hidden])~:not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(.5rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(.5rem * var(--tw-space-y-reverse))
}

.space-y-3>:not([hidden])~:not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(.75rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(.75rem * var(--tw-space-y-reverse))
}

.space-y-4>:not([hidden])~:not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(1rem * var(--tw-space-y-reverse))
}

.space-y-6>:not([hidden])~:not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(1.5rem * var(--tw-space-y-reverse))
}

.space-y-8>:not([hidden])~:not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(2rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(2rem * var(--tw-space-y-reverse))
}

.divide-x>:not([hidden])~:not([hidden]) {
    --tw-divide-x-reverse: 0;
    border-right-width: calc(1px * var(--tw-divide-x-reverse));
    border-left-width: calc(1px * calc(1 - var(--tw-divide-x-reverse)))
}

.divide-white>:not([hidden])~:not([hidden]) {
    --tw-divide-opacity: 1;
    border-color: rgb(255 255 255/var(--tw-divide-opacity))
}

.self-start {
    align-self: flex-start
}

.self-center {
    align-self: center
}

.overflow-hidden {
    overflow: hidden
}

.whitespace-nowrap {
    white-space: nowrap
}

.rounded-2xl {
    border-radius: 1rem
}

.rounded-full {
    border-radius: 9999px
}

.rounded-lg {
    border-radius: .5rem
}

.rounded-md {
    border-radius: .375rem
}

.rounded-xl {
    border-radius: .75rem
}

.rounded-t-xl {
    border-top-left-radius: .75rem;
    border-top-right-radius: .75rem
}

.border {
    border-width: 1px
}

.border-t {
    border-top-width: 1px
}

.border-gray-300 {
    --tw-border-opacity: 1;
    border-color: rgb(209 213 219/var(--tw-border-opacity))
}

.border-gray-400 {
    --tw-border-opacity: 1;
    border-color: rgb(156 163 175/var(--tw-border-opacity))
}

.border-transparent {
    border-color: transparent
}

.bg-\[\#f1f1f1\] {
    --tw-bg-opacity: 1;
    background-color: rgb(241 241 241/var(--tw-bg-opacity))
}

.bg-\[\#fddfb5\] {
    --tw-bg-opacity: 1;
    background-color: rgb(253 223 181/var(--tw-bg-opacity))
}

.bg-black {
    --tw-bg-opacity: 1;
    background-color: rgb(0 0 0/var(--tw-bg-opacity))
}

.bg-gray-200 {
    --tw-bg-opacity: 1;
    background-color: rgb(229 231 235/var(--tw-bg-opacity))
}

.bg-gray-300 {
    --tw-bg-opacity: 1;
    background-color: rgb(209 213 219/var(--tw-bg-opacity))
}

.bg-gray-50 {
    --tw-bg-opacity: 1;
    background-color: rgb(249 250 251/var(--tw-bg-opacity))
}

.bg-neutral-900 {
    --tw-bg-opacity: 1;
    background-color: rgb(23 23 23/var(--tw-bg-opacity))
}

.bg-orange-500 {
    --tw-bg-opacity: 1;
    background-color: rgb(249 115 22/var(--tw-bg-opacity))
}

.bg-white {
    --tw-bg-opacity: 1;
    background-color: rgb(255 255 255/var(--tw-bg-opacity))
}

.bg-gradient-to-r {
    background-image: linear-gradient(to right, var(--tw-gradient-stops))
}

.from-blue-400 {
    --tw-gradient-from: #60a5fa var(--tw-gradient-from-position);
    --tw-gradient-to: rgba(96, 165, 250, 0) var(--tw-gradient-to-position);
    --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to)
}

.to-blue-600 {
    --tw-gradient-to: #2563eb var(--tw-gradient-to-position)
}

.bg-contain {
    background-size: contain
}

.bg-cover {
    background-size: cover
}

.bg-center {
    background-position: 50%
}

.bg-left {
    background-position: 0
}

.bg-no-repeat {
    background-repeat: no-repeat
}

.object-cover {
    object-fit: cover
}

.p-2 {
    padding: .5rem
}

.p-2\.5 {
    padding: .625rem
}

.p-3 {
    padding: .75rem
}

.p-5 {
    padding: 1.25rem
}

.p-6 {
    padding: 1.5rem
}

.p-8 {
    padding: 2rem
}

.px-0 {
    padding-left: 0;
    padding-right: 0
}

.px-10 {
    padding-left: 2.5rem;
    padding-right: 2.5rem
}

.px-2 {
    padding-left: .5rem;
    padding-right: .5rem
}

.px-3 {
    padding-left: .75rem;
    padding-right: .75rem
}

.px-4 {
    padding-left: 1rem;
    padding-right: 1rem
}

.px-5 {
    padding-left: 1.25rem;
    padding-right: 1.25rem
}

.px-6 {
    padding-left: 1.5rem;
    padding-right: 1.5rem
}

.py-1 {
    padding-top: .25rem;
    padding-bottom: .25rem
}

.py-10 {
    padding-top: 2.5rem;
    padding-bottom: 2.5rem
}

.py-12 {
    padding-top: 3rem;
    padding-bottom: 3rem
}

.py-2 {
    padding-top: .5rem;
    padding-bottom: .5rem
}

.py-28 {
    padding-top: 7rem;
    padding-bottom: 7rem
}

.py-3 {
    padding-top: .75rem;
    padding-bottom: .75rem
}

.py-4 {
    padding-top: 1rem;
    padding-bottom: 1rem
}

.py-8 {
    padding-top: 2rem;
    padding-bottom: 2rem
}

.pb-3 {
    padding-bottom: .75rem
}

.pl-0 {
    padding-left: 0
}

.pl-5 {
    padding-left: 1.25rem
}

.pl-6 {
    padding-left: 1.5rem
}

.pr-2 {
    padding-right: .5rem
}

.pt-2 {
    padding-top: .5rem
}

.pt-5 {
    padding-top: 1.25rem
}

.text-center {
    text-align: center
}

.text-right {
    text-align: right
}

.text-justify {
    text-align: justify
}

.font-sans {
    font-family: ui-sans-serif, system-ui, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji
}

.text-2xl {
    font-size: 1.2rem;
    line-height: 2rem
}

.text-3xl {
    font-size: 1.875rem;
    line-height: 2.25rem
}

.text-4xl {
    font-size: 2.25rem;
    line-height: 2.5rem
}

.text-5xl {
    font-size: 3rem;
    line-height: 1
}

.text-base {
    font-size: 1rem;
    line-height: 1.5rem
}

.text-lg {
    font-size: 1.125rem;
    line-height: 1.75rem
}

.text-sm {
    font-size: .875rem;
    line-height: 1.25rem
}

.text-xl {
    font-size: 1.25rem;
    line-height: 1.75rem
}

.font-bold {
    font-weight: 700
}

.font-light {
    font-weight: 300
}

.font-medium {
    font-weight: 500
}

.font-normal {
    font-weight: 400
}

.font-semibold {
    font-weight: 600
}

.uppercase {
    text-transform: uppercase
}

.capitalize {
    text-transform: capitalize
}

.italic {
    font-style: italic
}

.leading-relaxed {
    line-height: 1.625
}

.tracking-wider {
    letter-spacing: .05em
}

.text-black {
    --tw-text-opacity: 1;
    color: rgb(0 0 0/var(--tw-text-opacity))
}

.text-blue-600 {
    --tw-text-opacity: 1;
    color: rgb(37 99 235/var(--tw-text-opacity))
}

.text-blue-800 {
    --tw-text-opacity: 1;
    color: rgb(30 64 175/var(--tw-text-opacity))
}

.text-blue-900 {
    --tw-text-opacity: 1;
    color: rgb(30 58 138/var(--tw-text-opacity))
}

.text-customBlue-500 {
    --tw-text-opacity: 1;
    color: rgb(1 52 117/var(--tw-text-opacity))
}

.text-gray-400 {
    --tw-text-opacity: 1;
    color: rgb(156 163 175/var(--tw-text-opacity))
}

.text-gray-600 {
    --tw-text-opacity: 1;
    color: rgb(75 85 99/var(--tw-text-opacity))
}

.text-gray-700 {
    --tw-text-opacity: 1;
    color: rgb(55 65 81/var(--tw-text-opacity))
}

.text-gray-800 {
    --tw-text-opacity: 1;
    color: rgb(31 41 55/var(--tw-text-opacity))
}

.text-gray-900 {
    --tw-text-opacity: 1;
    color: rgb(17 24 39/var(--tw-text-opacity))
}

.text-white {
    --tw-text-opacity: 1;
    color: rgb(255 255 255/var(--tw-text-opacity))
}

.text-yellow-400 {
    --tw-text-opacity: 1;
    color: rgb(250 204 21/var(--tw-text-opacity))
}

.underline {
    text-decoration-line: underline
}

.opacity-20 {
    opacity: .2
}

.shadow-lg {
    --tw-shadow: 0 10px 15px -3px rgba(0, 0, 0, .1), 0 4px 6px -4px rgba(0, 0, 0, .1);
    --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color)
}

.shadow-lg,
.shadow-md {
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)
}

.shadow-md {
    --tw-shadow: 0 4px 6px -1px rgba(0, 0, 0, .1), 0 2px 4px -2px rgba(0, 0, 0, .1);
    --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color)
}

.shadow-sm {
    --tw-shadow: 0 1px 2px 0 rgba(0, 0, 0, .05);
    --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color)
}

.shadow-sm,
.shadow-xl {
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)
}

.shadow-xl {
    --tw-shadow: 0 20px 25px -5px rgba(0, 0, 0, .1), 0 8px 10px -6px rgba(0, 0, 0, .1);
    --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color)
}

.filter {
    filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)
}

.transition {
    transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
    transition-timing-function: cubic-bezier(.4, 0, .2, 1);
    transition-duration: .15s
}

.transition-all {
    transition-property: all;
    transition-timing-function: cubic-bezier(.4, 0, .2, 1);
    transition-duration: .15s
}

.transition-colors {
    transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
    transition-timing-function: cubic-bezier(.4, 0, .2, 1);
    transition-duration: .15s
}

.transition-transform {
    transition-property: transform;
    transition-timing-function: cubic-bezier(.4, 0, .2, 1);
    transition-duration: .15s
}

.duration-300 {
    transition-duration: .3s
}

.duration-500 {
    transition-duration: .5s
}

.ease-in-out {
    transition-timing-function: cubic-bezier(.4, 0, .2, 1)
}

.font-sans {
    font-family: Lato, sans-serif
}

.font-serif {
    font-family: DM Sans, sans-serif
}

.font-alternate {
    font-family: Kristi, cursive
}

body {
    --tw-bg-opacity: 1;
    background-color: rgb(255 255 255/var(--tw-bg-opacity));
    font-family: ui-sans-serif, system-ui, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji;
    font-weight: 400;
    color: rgb(38 38 38/var(--tw-text-opacity));
    font-family: Lato, sans-serif
}

body,
body a {
    --tw-text-opacity: 1
}

body a {
    color: rgb(29 78 216/var(--tw-text-opacity));
    text-decoration-line: none
}

.gray-shadow {
    box-shadow: 0 0 14px 0 rgba(0, 0, 0, .2)
}

.text-shad {
    text-shadow: 0 0 15px 0 rgba(0, 0, 0, .2)
}

.text-shad-wh {
    text-shadow: 0 3px 1px 1px hsla(0, 0%, 100%, .8)
}

nav .navbar-menu a {
    font-family: ui-sans-serif, system-ui, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji;
    font-weight: 500;
    letter-spacing: .025em;
    font-family: Lato, sans-serif
}

body main p {
    margin-bottom: 1rem
}

h1,
h2,
h3,
h4,
h5,
h6 {
    font-family: DM Sans, sans-serif;
    line-height: 1.1em !important;
    letter-spacing: 0
}

h1 {
    margin-bottom: 1rem;
    font-size: 1.875rem;
    line-height: 2.25rem
}

@media (min-width:768px) {
    h1 {
        font-size: 3rem;
        line-height: 1
    }
}

@media (min-width:1024px) {
    h1 {
        font-size: 3.75rem;
        line-height: 1
    }
}

h1.heading {
    margin-bottom: 1rem;
    font-size: 1.5rem;
    line-height: 2rem
}

@media (min-width:768px) {
    h1.heading {
        font-size: 1.875rem;
        line-height: 2.25rem
    }
}

@media (min-width:1024px) {
    h1.heading {
        font-size: 3rem;
        line-height: 1
    }
}

h2 {
    margin-bottom: 1rem;
    font-size: 1.5rem;
    line-height: 2rem
}

@media (min-width:768px) {
    h2 {
        font-size: 1.875rem;
        line-height: 2.25rem
    }
}

@media (min-width:1024px) {
    h2 {
        font-size: 2.25rem;
        line-height: 2.5rem
    }
}

h3 {
    margin-bottom: 1rem;
    font-size: 1.5rem;
    line-height: 2rem
}

@media (min-width:768px) {
    h3 {
        font-size: 1.875rem;
        line-height: 2.25rem
    }
}

@media (min-width:1024px) {
    h3 {
        font-size: 2.25rem;
        line-height: 2.5rem
    }
}

h4 {
    margin-bottom: 1rem;
    font-size: 1.25rem;
    line-height: 1.75rem
}

@media (min-width:768px) {
    h4 {
        font-size: 1.5rem;
        line-height: 2rem
    }
}

@media (min-width:1024px) {
    h4 {
        font-size: 1.875rem;
        line-height: 2.25rem
    }
}

h5 {
    margin-bottom: 1rem;
    font-size: 1.125rem;
    line-height: 1.75rem
}

@media (min-width:768px) {
    h5 {
        font-size: 1.25rem;
        line-height: 1.75rem
    }
}

@media (min-width:1024px) {
    h5 {
        font-size: 1.5rem;
        line-height: 2rem
    }
}

h6 {
    margin-bottom: 1rem;
    font-size: 1rem;
    line-height: 1.5rem
}

@media (min-width:768px) {
    h6 {
        font-size: 1.125rem;
        line-height: 1.75rem
    }
}

@media (min-width:1024px) {
    h6 {
        font-size: 1.25rem;
        line-height: 1.75rem
    }
}

.page-heading {
    position: relative;
    overflow: hidden;
    background-size: cover;
    background-position: 50%;
    background-repeat: no-repeat
}

.page-heading:before {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    top: 0;
    height: 100%;
    width: 100%;
    overflow: hidden;
    background-attachment: fixed
}

.slider-sec {
    background-image: linear-gradient(0deg, #171717 40%, transparent 0), url(../assets/Home_Hero_Background_D_f9a09d8c5f.jpg);
    background-position: 50%
}

.gradient-1 {
    background-image: linear-gradient(0deg, #171717 40%, transparent 0);
    background-position: 50%
}

.gradient-2 {
    background-image: linear-gradient(0deg, transparent 40%, #171717 0);
    background-position: 50%
}

.gradient-ltr {
    background-image: linear-gradient(90deg, #3730a3 60%, transparent 0);
    background-position: 50%
}

.parallex1 {
    position: relative;
    width: 100%;
    overflow: hidden;
    background-size: cover;
    background-attachment: fixed;
    background-position: 50%;
    background-repeat: no-repeat
}

.parallex1:before {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    top: 0;
    width: 100%;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
    overflow: hidden;
    background-color: rgb(30 27 75/var(--tw-bg-opacity));
    --tw-bg-opacity: 0.9
}

.orange-tint {
    position: relative;
    width: 100%;
    overflow: hidden;
    background-size: cover;
    background-position: 50%;
    background-repeat: no-repeat
}

.orange-tint:before {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    top: 0;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
    background-color: rgb(234 88 12/var(--tw-bg-opacity));
    --tw-bg-opacity: 0.8
}

.black-tint,
.orange-tint:before {
    width: 100%;
    overflow: hidden;
    background-attachment: fixed
}

.black-tint {
    position: relative;
    background-size: cover;
    background-position: top;
    background-repeat: no-repeat
}

.black-tint:before {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    top: 0;
    width: 100%;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
    overflow: hidden;
    background-color: rgb(0 0 0/var(--tw-bg-opacity));
    --tw-bg-opacity: 0.8
}

.heading-vert {
    writing-mode: vertical-rl;
    rotate: 180deg
}

.embla {
    overflow: hidden
}

.embla__container {
    display: flex
}

.embla__slide {
    flex: 0 0 100%;
    min-width: 0
}

.page h2,
.page h3 {
    margin-top: 1.5rem
}

.page p {
    margin-top: .5rem
}

.before\:-z-10:before {
    content: var(--tw-content);
    z-index: -10
}

.hover\:bg-gray-100:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(243 244 246/var(--tw-bg-opacity))
}

.hover\:bg-gray-700:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(55 65 81/var(--tw-bg-opacity))
}

.hover\:bg-yellow-500:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(234 179 8/var(--tw-bg-opacity))
}

.hover\:from-blue-500:hover {
    --tw-gradient-from: #3b82f6 var(--tw-gradient-from-position);
    --tw-gradient-to: rgba(59, 130, 246, 0) var(--tw-gradient-to-position);
    --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to)
}

.hover\:to-blue-700:hover {
    --tw-gradient-to: #1d4ed8 var(--tw-gradient-to-position)
}

.hover\:text-customBlue-500:hover {
    --tw-text-opacity: 1;
    color: rgb(1 52 117/var(--tw-text-opacity))
}

.hover\:text-orange-500:hover {
    --tw-text-opacity: 1;
    color: rgb(249 115 22/var(--tw-text-opacity))
}

.hover\:text-yellow-400:hover {
    --tw-text-opacity: 1;
    color: rgb(250 204 21/var(--tw-text-opacity))
}

.hover\:text-yellow-600:hover {
    --tw-text-opacity: 1;
    color: rgb(202 138 4/var(--tw-text-opacity))
}

.hover\:underline:hover {
    text-decoration-line: underline
}

.hover\:shadow-lg:hover {
    --tw-shadow: 0 10px 15px -3px rgba(0, 0, 0, .1), 0 4px 6px -4px rgba(0, 0, 0, .1);
    --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)
}

.focus\:border-blue-500:focus {
    --tw-border-opacity: 1;
    border-color: rgb(59 130 246/var(--tw-border-opacity))
}

.focus\:outline-none:focus {
    outline: 2px solid transparent;
    outline-offset: 2px
}

.focus\:ring-2:focus {
    --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
    --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color)
}

.focus\:ring-2:focus,
.focus\:ring-4:focus {
    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000)
}

.focus\:ring-4:focus {
    --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
    --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color)
}

.focus\:ring-inset:focus {
    --tw-ring-inset: inset
}

.focus\:ring-blue-500:focus {
    --tw-ring-opacity: 1;
    --tw-ring-color: rgb(59 130 246/var(--tw-ring-opacity))
}

.focus\:ring-white:focus {
    --tw-ring-opacity: 1;
    --tw-ring-color: rgb(255 255 255/var(--tw-ring-opacity))
}

@media (min-width:640px) {
    .sm\:col-span-2 {
        grid-column: span 2/span 2 !important;
    }

    .sm\:ml-6 {
        margin-left: 1.5rem !important;
    }

    .sm\:block {
        display: block !important;
    }

    .sm\:hidden {
        display: none !important;
    }

    .sm\:w-fit {
        width: fit-content !important;
    }

    .sm\:grid-cols-3 {
        grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
    }

    .sm\:items-stretch {
        align-items: stretch !important;
    }

    .sm\:justify-start {
        justify-content: flex-start !important;
    }
}

@media (min-width:768px) {
    .md\:order-1 {
        order: 1 !important;
    }

    .md\:order-2 {
        order: 2 !important;
    }

    .md\:col-span-2 {
        grid-column: span 2/span 2 !important;
    }

    .md\:col-span-3 {
        grid-column: span 3/span 3 !important;
    }

    .md\:col-span-full {
        grid-column: 1/-1 !important;
    }

    .md\:row-span-1 {
        grid-row: span 1/span 1 !important;
    }

    .md\:my-8 {
        margin-top: 2rem !important;
        margin-bottom: 2rem !important;
    }

    .md\:mb-0 {
        margin-bottom: 0 !important;
    }

    .md\:mb-6 {
        margin-bottom: 1.5rem !important;
    }

    .md\:mb-8 {
        margin-bottom: 2rem !important;
    }

    .md\:mr-36 {
        margin-right: 9rem !important;
    }

    .md\:mr-8 {
        margin-right: 2rem !important;
    }

    .md\:mt-0 {
        margin-top: 0 !important;
    }

    .md\:mt-8 {
        margin-top: 2rem !important;
    }

    .md\:block {
        display: block !important;
    }

    .md\:grid {
        display: grid !important;
    }

    .md\:w-1\/2 {
        width: 50% !important;
    }

    .md\:w-80 {
        width: 20rem !important;
    }

    .md\:w-\[12rem\] {
        width: 12rem !important;
    }

    .md\:min-w-28 {
        min-width: 7rem !important;
    }

    .md\:grid-cols-2 {
        grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
    }

    .md\:grid-cols-3 {
        grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
    }

    .md\:grid-cols-4 {
        grid-template-columns: repeat(4, minmax(0, 1fr)) !important;
    }

    .md\:grid-cols-5 {
        grid-template-columns: repeat(5, minmax(0, 1fr)) !important;
    }

    .md\:grid-cols-6 {
        grid-template-columns: repeat(6, minmax(0, 1fr)) !important;
    }

    .md\:flex-row {
        flex-direction: row !important;
    }

    .md\:gap-6 {
        gap: 1.5rem !important;
    }

    .md\:space-y-3>:not([hidden])~:not([hidden]) {
        --tw-space-y-reverse: 0 !important;
        margin-top: calc(.75rem * calc(1 - var(--tw-space-y-reverse))) !important;
        margin-bottom: calc(.75rem * var(--tw-space-y-reverse)) !important;
    }

    .md\:p-8 {
        padding: 2rem !important;
    }

    .md\:px-10 {
        padding-left: 2.5rem !important;
        padding-right: 2.5rem !important;
    }

    .md\:px-12 {
        padding-left: 3rem !important;
        padding-right: 3rem !important;
    }

    .md\:py-10 {
        padding-top: 2.5rem !important;
        padding-bottom: 2.5rem !important;
    }

    .md\:py-16 {
        padding-top: 4rem !important;
        padding-bottom: 4rem !important;
    }

    .md\:py-20 {
        padding-top: 5rem !important;
        padding-bottom: 5rem !important;
    }

    .md\:text-left {
        text-align: left !important;
    }

    .md\:text-right {
        text-align: right !important;
    }

    .md\:text-3xl {
        font-size: 1.875rem !important;
        line-height: 2.25rem !important;
    }

    .md\:text-4xl {
        font-size: 2.25rem !important;
        line-height: 2.5rem !important;
    }

    .md\:text-base {
        font-size: 1rem !important;
        line-height: 1.5rem !important;
    }

    .md\:text-lg {
        font-size: 1.125rem !important;
        line-height: 1.75rem !important;
    }

    .md\:text-xl {
        font-size: 1.25rem !important;
        line-height: 1.75rem !important;
    }
}

@media (min-width:1024px) {
    .lg\:order-1 {
        order: 1 !important;
    }

    .lg\:col-span-1 {
        grid-column: span 1/span 1 !important;
    }

    .lg\:col-span-2 {
        grid-column: span 2/span 2 !important;
    }

    .lg\:col-span-3 {
        grid-column: span 3/span 3 !important;
    }

    .lg\:col-span-4 {
        grid-column: span 4/span 4 !important;
    }

    .lg\:mx-auto {
        margin-left: auto !important;
        margin-right: auto !important;
    }

    .lg\:-ml-20 {
        margin-left: -5rem !important;
    }

    .lg\:mb-0 {
        margin-bottom: 0 !important;
    }

    .lg\:ml-20 {
        margin-left: 5rem !important;
    }

    .lg\:w-2\/5 {
        width: 40% !important;
    }

    .lg\:w-3\/5 {
        width: 60% !important;
    }

    .lg\:grid-cols-2 {
        grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
    }

    .lg\:grid-cols-4 {
        grid-template-columns: repeat(4, minmax(0, 1fr)) !important;
    }

    .lg\:grid-cols-5 {
        grid-template-columns: repeat(5, minmax(0, 1fr)) !important;
    }

    .lg\:flex-row {
        flex-direction: row !important;
    }

    .lg\:gap-4 {
        gap: 1rem !important;
    }

    .lg\:rounded-r-\[3rem\] {
        border-top-right-radius: 3rem !important;
        border-bottom-right-radius: 3rem !important;
    }

    .lg\:py-12 {
        padding-top: 3rem !important;
        padding-bottom: 3rem !important;
    }

    .lg\:py-20 {
        padding-top: 5rem !important;
        padding-bottom: 5rem !important;
    }

    .lg\:pl-16 {
        padding-left: 4rem !important;
    }

    .lg\:pr-24 {
        padding-right: 6rem !important;
    }

    .lg\:pr-28 {
        padding-right: 7rem !important;
    }

    .lg\:text-2xl {
        font-size: 1.5rem !important;
        line-height: 2rem !important;
    }

    .lg\:text-xl {
        font-size: 1.25rem !important;
        line-height: 1.75rem !important;
    }
}


.rtl\:space-x-reverse:where([dir=rtl], [dir=rtl] *)>:not([hidden])~:not([hidden]) {
    --tw-space-x-reverse: 1
}

@media (prefers-color-scheme:dark) {
    .dark\:text-gray-300 {
        --tw-text-opacity: 1;
        color: rgb(209 213 219/var(--tw-text-opacity))
    }

    .dark\:text-gray-400 {
        --tw-text-opacity: 1;
        color: rgb(156 163 175/var(--tw-text-opacity))
    }

    .dark\:text-white {
        --tw-text-opacity: 1;
        color: rgb(255 255 255/var(--tw-text-opacity))
    }
}
</style>